import { TransformationType, TransformFnParams, TransformOptions } from "class-transformer";
import {
  ContainerAlertCargoSubtypeOptions,
  ContainerAlertCargoSubtypeOptionsEntity
} from "../container-alert-cargo-subtype-options";
import { ContainerAlertOptionsEntity } from "../container-alert-options";
import { toTransportCategory, transportCategory, TransportCategory } from "../transport-category";
import { DatabaseCode } from "../database-code";

export type Transformer = (
  transformFn: (params: TransformFnParams) => any,
  options?: TransformOptions
) => PropertyDecorator;

export const getTransportCategoryTransformer = (
  defaultValue: TransportCategory | undefined = transportCategory.water
): ((transformerParams: TransformFnParams) => any) => {
  return getDatabaseCodeTransformer(toTransportCategory, defaultValue);
};

export function getDatabaseCodeTransformer<T extends DatabaseCode>(
  typeTransformer: (value: string) => T,
  defaultValue: T | undefined = undefined
): (transformerParams: TransformFnParams) => any {
  function transformer(params: TransformFnParams): any {
    switch (params.type) {
      case TransformationType.CLASS_TO_CLASS:
        return params.obj[params.key];
      case TransformationType.CLASS_TO_PLAIN:
        return params.obj[params.key]?.code;
      case TransformationType.PLAIN_TO_CLASS:
        if (!params.value) {
          return defaultValue;
        }
        return typeTransformer(params.value);
    }
  }

  return transformer;
}

export function getDatabaseCodeArrayTransformer<T extends DatabaseCode>(
  typeTransformer: (value: string) => T,
  defaultValue: T[] | undefined = undefined
): (transformerParams: TransformFnParams) => any {

  function transformer(params: TransformFnParams): any {
    if (params.type === TransformationType.CLASS_TO_CLASS) {
      return params.obj[params.key];
    } else if (params.type === TransformationType.CLASS_TO_PLAIN) {
      return params.obj[params.key]?.map((v: T) => v.code);
    } else if (params.type === TransformationType.PLAIN_TO_CLASS) {
      if (!params.value) {
        return defaultValue;
      }
      const values = Array.isArray(params.value)
        ? params.value
        : [params.value];

      return values.map((v: string) => typeTransformer(v));
    }
  }

  return transformer;
}

export const transformCargoSubtypeOptionsArray = (params: {
  value: ContainerAlertCargoSubtypeOptions[] | undefined | null;
  obj: ContainerAlertOptionsEntity;
  type: TransformationType;
}): any => {
  switch (params.type) {
    case TransformationType.CLASS_TO_CLASS:
      return params.obj.cargoSubtypeOptions;
    case TransformationType.CLASS_TO_PLAIN:
      return params.obj.cargoSubtypeOptions.map((o) => {
        o.toTypeValue()
          .then((cso) => {
            return cso;
          })
          .catch(() => {
            return undefined;
          });
      });
    case TransformationType.PLAIN_TO_CLASS:
      if (!params.value) {
        return [];
      }
      return params.value.map((v) =>
        ContainerAlertCargoSubtypeOptionsEntity.from(v)
      );
  }
};
